import React from 'react';
import AActionSheet from 'antd-mobile/lib/action-sheet';


export default AActionSheet;

